/*
 * @Description: 日程管理 - 归档API
 * @Author: AI Assistant
 * @Date: 2023-10-30
 */

import request from '@/utils/request'

/**
 * 获取归档列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getArchiveList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/schedule/archive/list',
      method: 'get',
      params
    }).then(res => {
      resolve(res);
    }).catch(err => {
      console.error('获取归档列表失败，使用本地存根数据', err);
      // 返回示例数据作为后备
      resolve({
        status: '10000',
        message: '成功(本地存根数据)',
        data: [
          { _id: 'stub_archive_1', name: '示例归档 1', description: '这是一个存根数据' },
          { _id: 'stub_archive_2', name: '示例归档 2', description: '这是一个存根数据' },
          { _id: 'stub_archive_3', name: '示例归档 3', description: '这是一个存根数据' }
        ]
      });
    });
  });
}

/**
 * 添加归档
 * @param {Object} data - 归档数据
 * @returns {Promise}
 */
export function addArchive(data) {
  return request({
    url: '/schedule/archive/add',
    method: 'post',
    data
  })
}

/**
 * 编辑归档
 * @param {Object} data - 归档数据
 * @returns {Promise}
 */
export function editArchive(data) {
  return request({
    url: '/schedule/archive/edit',
    method: 'post',
    data
  })
}

/**
 * 删除归档
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function deleteArchive(data) {
  return request({
    url: '/schedule/archive/delete',
    method: 'post',
    data
  })
}

/**
 * 获取归档详情
 * @param {Object} params - 包含id的参数对象
 * @returns {Promise}
 */
export function getArchiveDetail(params) {
  return request({
    url: '/schedule/archive/detail',
    method: 'get',
    params
  })
}

/**
 * 更新归档主题样式
 * @param {Object} data - 包含id和themeStyle的参数对象
 * @returns {Promise}
 */
export function updateArchiveTheme(data) {
  return request({
    url: '/schedule/archive/updateTheme',
    method: 'post',
    data
  })
} 